import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {sendToSalesforce, useDispatch, useGuideConfig, NeuroMessage, ShareViaEmailForm} from '@ignitesales/neuro-application';
import ConnectedContactFlow from "@ignitesales/neuro-application/src/neuro-guide/components/ContactFlow/ConnectedContactFlow";
import getFormFields from "../utils/getFormFields.mjs";
import {onContactPageCompleted} from "../state/DialogueActions.mjs";
import {useDialogueGuideSettings} from "../hooks/useDialogueGuideSettings.mjs";
import {notifySuccess} from "@ignitesales/neuro-application/src/neuro-guide/components/ToastNotifications";
import { ActionService } from '../services/ActionService.mjs';

//TODO: implement "enableShareViaEmailToggle" checkbox in neuro contact form component, have it trigger shareViaEmail on submit
const ContactForm = ({ componentClass, onComplete }) => {
    const appDispatch = useDispatch();
    const { isUsingSalesforce, isBranchGuide, guideType } = useGuideConfig();
    const { contactType, showCustomerId } = useDialogueGuideSettings();
    const isBusinessGuide = guideType === 'business';
    const [ actions, setActions ] = useState(undefined);
    const [ apiConfig, setApiConfig ] = useState(undefined);

    useEffect(() => {
        const fetchData = async () => {
            if (!actions) {
                try {
                    const actionsData = await ActionService.getActionsByTriggerType('contactSubmit');
                    if (actionsData.length) { //dont need to set api config if we dont have actions
                        const guideAttributes = await window.ignite.userService.getGuideAttributes();
                        setActions(actionsData);
                        setApiConfig(guideAttributes.dialogueApiConfig);
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }
        };
        
        fetchData();
    }, [actions]);

    const onFormComplete = (result) => {
        notifySuccess( 'contactFormPageToast');
        appDispatch(onContactPageCompleted());
        if(isUsingSalesforce) {
            appDispatch(sendToSalesforce());
        }
        onComplete && onComplete(result);
    };

    return <div className={`${componentClass}__content`}>
        <div className={`${componentClass}__header`}>
            <NeuroMessage id='contactFormPage.title' tagName='h1' />
            <NeuroMessage id='contactFormPage.text' tagName='p' shouldHideIfNotFound={true} />
        </div>
        <section>
            { contactType === 'emailOnly'
                ? <ShareViaEmailForm onSubmit={onFormComplete} />
                : <ConnectedContactFlow dialogueApiConfig={apiConfig} actions={actions} onComplete={onFormComplete} useAppointmentFlow={false} fields={getFormFields(isBranchGuide, isBusinessGuide, showCustomerId)}/>
            }
        </section>
        <NeuroMessage id='contactFormPage.footer' tagName='div' className={`${componentClass}__footer`} shouldHideIfNotFound={true} />
    </div>;
};

ContactForm.propTypes = {
    componentClass: PropTypes.string.isRequired
};

export default ContactForm;
